import {
    CLAPI
} from '../clchart/cl.api.js'
import { formatFloat } from '../clchart/cl.utils.js'
import * as DATAS from '../datas/transdata.js'

export const FWIDTH = 130

export const MCLASSS = ['zeasy0']
// export const MCLASSS = ['ftrend0', 'ftrend1']

export const MINUTES = [945, 1045, 1330, 1445]

export const CHART_SIGNAL_MCLASS = {
    style: 'horizontal', // 'vertical'
    title: {
        width: FWIDTH,
        label: '信号分类',
    },
    maxchs: 4,
    ctrls: []
}

export function onInit() {
    CHART_SIGNAL_MCLASS.ctrls = []
    for (let wvi = 0; wvi < MCLASSS.length; wvi++) {
        CHART_SIGNAL_MCLASS.ctrls.push({
            label: MCLASSS[wvi],
            clickValue: MCLASSS[wvi],
        })
    }
}

export const CHART_SIGNAL_DATES = {
    style: 'vertical', // 'vertical'
    title: {
        label: '集合',
        height: 23,
    },
    ctrls: []
}
export function setDatesTitle(name) {
    CHART_SIGNAL_DATES.title.label = name
}
export function clearDates() {
    CHART_SIGNAL_DATES.ctrls = []
}
export function incrDates(fname, vrate) {
    // console.log(fname);
    const info = {
        label: fname,
        clickValue: fname,
        value : [],
    }
    if (vrate !== undefined) {
        let clr = 'txt'
        if (vrate > 0) {
            clr = 'red'
        }
        if (vrate < 0) {
            clr = 'green'
        }
        info.value.push({
            label : formatFloat(Math.abs(vrate) * 100.0, 1, 4) + '%',
            color : clr,
        })
    }
    CHART_SIGNAL_DATES.ctrls.push(info)
}
export function setDatesValue(fname, vrate) {
    for (let index = 0; index < CHART_SIGNAL_DATES.ctrls.length; index++) {
        const ctrl = CHART_SIGNAL_DATES.ctrls[index];
        
        // console.log(typeof ctrl.clickValue, typeof fname, ctrl.clickValue === fname);
        if (ctrl.clickValue === fname.toString()) {
            let clr = 'txt'
            if (vrate > 0) {
                clr = 'red'
            }
            if (vrate < 0) {
                clr = 'green'
            }
            ctrl.value[0].label = formatFloat(Math.abs(vrate) * 100.0, 1, 4) + '%'
            ctrl.value[0].color = clr
        }      
    }
}

const chartFocus = []
export function clearFocus() {
    chartFocus.length = 0
}
export function changeFocus(chartName, cvname, redraw) {
    console.log(chartName, cvname);
    let findidx = -1
    for (let index = 0; index < chartFocus.length; index++) {
        if (chartFocus[index].chartName === chartName && chartFocus[index].cvname === cvname) {
            findidx = index;
            break;
        }       
    }
    let oldfocus = -1
    for (let index = 0; index < chartFocus.length; index++) {
        if (chartFocus[index].focus) {
            oldfocus = index;
        }       
    }
    const curChart = Init.getSysChart()
    let newfocus = -1
    if (findidx < 0) {
        // 以前没有
        const chart = curChart.getUserChart(chartName, cvname)
        if (chart !== undefined) {
            newfocus = chartFocus.length
            chartFocus.push({
                chartName, 
                cvname, 
                focus : true, 
            })
        }
    }
    else {
        if (redraw || !chartFocus[findidx].focus) {
            newfocus = findidx
        }
    }
    // console.log(findidx, oldfocus, newfocus);
    if (newfocus >= 0) {
        if (oldfocus >= 0) {
            const chart = curChart.getUserChart(chartFocus[oldfocus].chartName, chartFocus[oldfocus].cvname)
            // console.log(chart.name, false);
            chart.setFocused(false)
            chartFocus[oldfocus].focus = false
        }
        const chart = curChart.getUserChart(chartFocus[newfocus].chartName, chartFocus[newfocus].cvname)
        // console.log(chart, chartFocus);
        // console.log(oldfocus, newfocus, chart.name, true);
        chart.setFocused(true)
        chartFocus[newfocus].focus = true
    
    }
    return newfocus !== oldfocus
}

export function setFocus() {
    let curfocus = -1
    for (let index = 0; index < chartFocus.length; index++) {
        if (chartFocus[index].focus) {
            curfocus = index;
        }       
    }
    // console.log(curfocus);
        
    if (curfocus >= 0) {
        const curChart = Init.getSysChart()
        const chart = curChart.getUserChart(chartFocus[curfocus].chartName, chartFocus[curfocus].cvname)
        chart.setFocused(true)
    }
}

const signal_fields = 'code,msecstamp,status,midp,avgr,fright,dates0,dates1,dates2,dates3,drate0,drate1,drate2,drate3,minus0,minus1,minus2,minus3,mrate0,mrate1,mrate2,mrate3'

const FIELD_SIGNAL = DATAS.fieldsMergeFieldsIndex('index,name,newp,rate,signals,nums0,nums1,nums2,nums3', signal_fields)

const ARRAY_SIGNAL = DATAS.strsToArray(signal_fields);

export const signalInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 4,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '时间',
        maxchs: 5,
        field: 'msecstamp',
        getclr : 'getCodeClr', 
        getvar : 'getMinuVar', 
    },
    {
        label: '最新价',
        maxchs: 6,
        field: 'newp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '总涨幅',
        maxchs: 6,
        field: 'rate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '当时价',
        maxchs: 6,
        field: 'midp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '价区间',
        maxchs: 6,
        field: 'avgr',
        getclr : 'getZeroClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '1日数',
        maxchs: 4,
        field: 'nums0',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '1日幅',
        maxchs: 6,
        field: 'mrate0',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '5日数',
        maxchs: 5,
        field: 'nums1',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '5日幅',
        maxchs: 6,
        field: 'mrate1',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '10日数',
        maxchs: 5,
        field: 'nums2',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '10日幅',
        maxchs: 6,
        field: 'mrate2',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '60日数',
        maxchs: 6,
        field: 'nums3',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '60日幅',
        maxchs: 6,
        field: 'mrate3',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
];

export const signalNowInfo = [
    {
        label: '序号',
        field: 'index',
        maxchs: 4,
        align: 'center', // align 默认为'right'
        sort: 'resume',     // sort默认为 number  resume表示原来的序列
        getclr : 'getIntClr',
        getvar : 'getIntVar',  
    },
    {
        label: '代码',
        field: 'code',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        sort: 'string', 
        getclr : 'getCodeClr',
        getvar : 'getStrVar',  
    },
    {
        label: "名称",
        field: 'name',
        maxchs: 8,
        align: 'left',  // alignTxt 默认为'right'
        style: 'click',  // 返回 click 事件 返回 label 信息
        getclr : 'getNameClr',
        getvar : 'getStrVar',  
    },
    {
        label: '最新价',
        maxchs: 6,
        field: 'newp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '涨幅',
        maxchs: 6,
        field: 'rate',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '时间',
        maxchs: 5,
        field: 'msecstamp',
        getclr : 'getCodeClr', 
        getvar : 'getMinuVar', 
    },
    {
        label: '当时价',
        maxchs: 6,
        field: 'midp',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getPrcClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '信号数',
        maxchs: 6,
        field: 'signals',
        change: true,   // change:true 表示如果数值有变化，显示动画效果
        getclr : 'getVolClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '持仓',
        maxchs: 6,
        field: 'avgr',
        getclr : 'getVolClr', 
        getvar : 'getPrcVar', 
    },
    {
        label: '1区',
        maxchs: 4,
        field: 'nums0',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '1区幅',
        maxchs: 6,
        field: 'mrate0',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '2区',
        maxchs: 5,
        field: 'nums1',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '2区幅',
        maxchs: 6,
        field: 'mrate1',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '3区',
        maxchs: 5,
        field: 'nums2',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '3区幅',
        maxchs: 6,
        field: 'mrate2',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
    {
        label: '4区',
        maxchs: 6,
        field: 'nums3',
        getclr : 'getIntClr', 
        getvar : 'getIntVar', 
    },
    {
        label: '4区幅',
        maxchs: 6,
        field: 'mrate3',
        getclr : 'getZeroClr', 
        getvar : 'getPctVar', 
    },
];

export function InfoSetNewp(ninfos, newpInfo, ainfos) {
    if (newpInfo === undefined) {
        newpInfo = {}
    }
    for (let index = 0; index < ninfos.datas.length; index++) {
        const code = CLAPI.getData(ninfos, 'code', index)
        let midp = CLAPI.getData(ninfos, 'newprc', index)
        if (midp < 0.01) {
            for (let ai = 0; ai < ainfos.datas.length; ai++) {
                if (code === CLAPI.getData(ainfos, 'code', ai)) {
                    midp = CLAPI.getData(ainfos, 'agoprc', ai)
                    break;
                }               
            }
        }
        const curDate = CLAPI.Utils.getMsecDate(CLAPI.getData(ninfos, 'msec', index))
        if (newpInfo[code] === undefined) {
            newpInfo[code] = { date : curDate, newp : midp}
        }
        if (curDate >= newpInfo[code].date) {
            newpInfo[code].date = curDate
            newpInfo[code].newp = midp
        }
    }
    return newpInfo
}
// const signal_fields = 'code,msecstamp,status,midp,avgr,fright,dates0,dates1,dates2,dates3,drate0,drate1,drate2,drate3,minus0,minus1,minus2,minus3,mrate0,mrate1,mrate2,mrate3'
export function transAsignal(indata, newpInfo) {
    let signals = []
    if (indata.infos) {
        let codes = {}
        let fhold = 1.0
        let minui = -1
        for (let index = 0; index < indata.infos.length; index++) {
            if (indata.infos[index].kname[0] === 'C') {
                if (indata.infos[index].kname === 'CG000000' || indata.infos[index].kname === 'CN000001') {
                    const minu = Math.round(indata.infos[index].minute)
                    minui = -1;
                    for (let mi = 0; mi < MINUTES.length; mi++) {
                        if (MINUTES[mi] === minu) {
                            minui = mi
                        }
                    }
                }
                else if (indata.infos[index].kname === 'CN000001') {
                    fhold = indata.infos[index].fhold
                }
                continue
            }
            const code = indata.infos[index].kname
            if (minui < 0) {
                minui = Math.round(indata.infos[index].minute)
            }
            if (minui >= 0) {
                if (codes[code] === undefined) {
                    codes[code] = { minus : [0, 0, 0, 0] , midp : [0.0, 0.0, 0.0, 0.0]}
                }
                codes[code].msec = CLAPI.Utils.strMsecToMTime(indata.infos[index].msecstamp)
                codes[code].status = indata.infos[index].status
                codes[code].newp   = indata.infos[index].midp
                codes[code].midp[minui] = indata.infos[index].midp
                codes[code].minus[minui] = 1
            }
            console.log(code, codes[code]);
            
            const curDate = CLAPI.Utils.getMsecDate(codes[code].msec)
            if (curDate >= newpInfo[code].date) {
                newpInfo[code].date = curDate
                newpInfo[code].newp = indata.infos[index].midp
            }
        }
        // console.log(codes);
        
        for (let code in codes) {
            const rate0 = (codes[code].newp < 0.1 || codes[code].midp[0] < 0.1) ? 0.0 : (codes[code].newp - codes[code].midp[0]) / codes[code].midp[0]
            const rate1 = (codes[code].newp < 0.1 || codes[code].midp[1] < 0.1) ? 0.0 : (codes[code].newp - codes[code].midp[1]) / codes[code].midp[1]
            const rate2 = (codes[code].newp < 0.1 || codes[code].midp[2] < 0.1) ? 0.0 : (codes[code].newp - codes[code].midp[2]) / codes[code].midp[2]
            const rate3 = (codes[code].newp < 0.1 || codes[code].midp[3] < 0.1) ? 0.0 : (codes[code].newp - codes[code].midp[3]) / codes[code].midp[3]
            // console.log(code, codes[code].newp, codes[code].midp);
            // let nums = 0
            // for (let ni = 1; ni < 4; ni++) {
            //    nums += codes[code].minus[ni]    
            // }
            // console.log(code, codes[code].minus[0]);
            signals.push([
                code,
                codes[code].msec,
                codes[code].status,
                codes[code].newp,
                fhold,
                1.0,
                -1,0,0,0,0,0,0,0,
                codes[code].minus[0],
                codes[code].minus[1],
                codes[code].minus[2],
                codes[code].minus[3],
                rate0,
                rate1,
                rate2,
                rate3,
            ])
        }
    }
    return { fields : DATAS.fieldsToFieldsIndex(signal_fields), datas: signals}    
}
// const FIELD_SIGNAL = DATAS.fieldsMergeFieldsIndex('index,name,msec,newp,rate', signal_fields)
export function GetAsignalTable(indata, keyInfo, newpInfo) {
    let signal = []
    let codes = {}
    for (let index = 0; index < indata.datas.length; index++) {
        let real = CLAPI.getData(indata, 'dates0', index)
        let nums = 0
        if (real == -1) {
            for (let ni = 0; ni < 4; ni++) {
                nums += CLAPI.getData(indata, 'minus' + ni.toString(), index)  
            }
            real = 0
        }
        else {
            nums = real + CLAPI.getData(indata, 'minus0', index)
        }
        if (nums < 1) {
            continue
        }
        // console.log(CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msecstamp', index)));
        
        const code = CLAPI.getData(indata, 'code', index)
        const midp = CLAPI.getData(indata, 'midp', index)
        // console.log(code, newpInfo[code].newp, midp);
        if (midp < 0.1) {
            continue
        }
        const rate = newpInfo[code] === undefined ? 0.0 : (newpInfo[code].newp - midp) / midp
        signal = [
            keyInfo[code].static.name,
            newpInfo[code].newp,
            rate,
            nums,
            real + CLAPI.getData(indata, 'minus0', index),
            CLAPI.getData(indata, 'dates1', index) + CLAPI.getData(indata, 'minus1', index),
            CLAPI.getData(indata, 'dates2', index) + CLAPI.getData(indata, 'minus2', index),
            CLAPI.getData(indata, 'dates3', index) + CLAPI.getData(indata, 'minus3', index),
        ]
        for (let fdi = 0; fdi < ARRAY_SIGNAL.length; fdi++) {
            signal.push(CLAPI.getData(indata, ARRAY_SIGNAL[fdi], index))
        }
        if (codes[code] === undefined) {
            codes[code] = { signal, nums : 1}
        }
        else {
            codes[code].signal = signal
            codes[code].nums ++
        }
    }
    // console.log(FIELD_SIGNAL);
    let signals = []
    for (let codeinfo in codes) {
        codes[codeinfo].signal.unshift(signals.length + 1)
        signals.push(codes[codeinfo].signal)
    }
    return { fields : FIELD_SIGNAL, datas: signals}    
}
